import { Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import SmoothScroll from "@/components/SmoothScroll";
import RouteTracker from "@/components/RouteTracker";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Espace from "@/pages/Espace";
import { Toaster } from "@/components/ui/sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-korban-navy text-korban-ink p-8">
          <p className="font-display text-xl text-korban-gold">
            Une erreur est survenue. Rechargez la page.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <RouteTracker />
          <AuthProvider>
            <SmoothScroll>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/connexion" element={<Login />} />
                <Route path="/espace" element={<Espace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Toaster position="top-center" richColors />
            </SmoothScroll>
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
